

export class ReminderSmsOutput implements IReminderSmsOutput {
    /** The auto-generated id of the sms reminder master */
    reminder_sms_id!: number;
    /** Mobile number */
    mobile_number!: string;

    constructor(data?: IReminderSmsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reminder_sms_id = _data["reminder_sms_id"];
            this.mobile_number = _data["mobile_number"];
        }
    }

    static fromJS(data: any): ReminderSmsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ReminderSmsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reminder_sms_id"] = this.reminder_sms_id;
        data["mobile_number"] = this.mobile_number;
        return data; 
    }
}

export interface IReminderSmsOutput {
    /** The auto-generated id of the sms reminder master */
    reminder_sms_id: number;
    /** Mobile number */
    mobile_number: string;
}

